import { render, staticRenderFns } from "./SpecialistLicense.vue?vue&type=template&id=3f053c27&scoped=true"
import script from "./SpecialistLicense.vue?vue&type=script&lang=js"
export * from "./SpecialistLicense.vue?vue&type=script&lang=js"
import style0 from "./SpecialistLicense.vue?vue&type=style&index=0&id=3f053c27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f053c27",
  null
  
)

export default component.exports